import {
  Component,
  OnInit,
  ElementRef,
  AfterViewInit,
  ViewChild,
} from "@angular/core";
import { EventService } from "../../core/services/event.service";
import { CampaignService } from "../../core/services/campaign.service";
import { HospitalService } from "../../core/services/hospital.service";
import { QuizService } from "../../core/services/quiz.service";
import { Chart } from "chart.js";
import { FormGroup } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { Auth } from "src/app/core/models/auth.models";
import { AuthenticationService } from "src/app/core/services/auth.service";
import Swal from "sweetalert2";

export interface Deposit {
  value: string;
  viewValue: string;
}

export class depositCreate {
  title: string;
}

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit, AfterViewInit {
  constructor(
    private eref: ElementRef,
    public http: HttpClient,
    public auth: AuthenticationService,
    private eventService: EventService,
    public service: CampaignService,
    public serviceDesk: HospitalService,
    public srvQuiz: QuizService
  ) {}

  campaings = [];

  states: any = [];
  cities: any = [];
  services: any = [];
  posto: any = {};
  data: any = [];

  filter = {
    campaign_id: null,
    state: null,
    city: null,
    hospital_id: null,
  };

  diagnostics: any = [];
  campaing: any = null;
  type = null;
  consult = null;

  chart: any;
  canvas: any;
  ctx: any;

  retorno: any = {
    ficha: [],
  };

  async ngOnInit() {
    this.eventService.broadcast("changePageHeading", {
      title: "Dashboard",
      breadcrumb: [
        { label: "SBD", active: true },
        { label: "Dashboard", active: true },
      ],
    });
  }

  isAdmin = false
  async ngAfterViewInit() {
    this.service.list().subscribe((result) => {
      this.campaings = result.data;
    });
    this.serviceDesk.getAll().subscribe(async (result) => {
      let data = result.data;

      let user: any = this.auth.currentUser();
      let filter_hospital = data.map((d) => d._id);
      if (user) if (user.profile !== "a" && user.name !== "admin") filter_hospital = user.hospital;
      this.data = data.filter((d) => filter_hospital.includes(d._id));
      this.isAdmin = user.profile !== "a"
      this.getStates();

      this.services = this.data
        .map((n) => {
          return { value: n._id, label: n.name };
        })
        .sort();
      if (this.isAdmin) {
        this.filter.hospital_id = this.services.map((s) => s.value);
      }
    });
  }

  getStates() {
    this.cities = [];
    this.states = Array.from(
      new Set<any>(this.data.map((c) => c.state))
    ).sort();
  }

  getCities(e) {
    this.cities = Array.from(
      new Set<any>(
        this.data.filter((c) => c.state === e.target.value).map((n) => n.city)
      )
    ).sort();

    if (this.filter.state === null) {
      this.services = Array.from(
        new Set<any>(
          this.data.map((n) => {
            return { value: n._id, label: n.name };
          })
        )
      ).sort();
    } else {
      this.services = Array.from(
        new Set<any>(
          this.data
            .filter((c) => c.state === this.filter.state)
            .map((n) => {
              return { value: n._id, label: n.name };
            })
        )
      ).sort();
    if (this.isAdmin) {
      this.filter.hospital_id = this.services.map((s) => s.value);
    }
    this.filter.city = null;
  }
  }

  getServices() {
    if (this.filter.city === null) {
      this.services = Array.from(
        new Set<any>(
          this.data
            .filter((c) => c.state === this.filter.state)
            .map((n) => {
              return { value: n._id, label: n.name };
            })
        )
      ).sort();
    } else {
      this.services = Array.from(
        new Set<any>(
          this.data
            .filter(
              (c) =>
                c.state === this.filter.state && c.city === this.filter.city
            )
            .map((n) => {
              return { value: n._id, label: n.name };
            })
        )
      ).sort();
    }
    if (this.isAdmin) {
      this.filter.hospital_id = this.services.map((s) => s.value);
    } else {
      this.filter.hospital_id = null;
    }
  }

  report() {
    if (!this.filter.campaign_id) {
      Swal.fire({
        title: `Oops!`,
        text: "Você selecionar a campanha",
        type: "error",
        confirmButtonColor: "#0f7b6c",
        allowOutsideClick: false,
      });
      return;
    }
    
    if (this.filter.hospital_id && this.filter.hospital_id[0] == null) {
      this.filter.hospital_id = null
    }
    
    this.loading = true;
    this.srvQuiz.search(this.filter).subscribe((data) => {
      if (data.total_hospital == 0) {
        data.total_quiz = 0
      }
      this.retorno = data;
      this.normalizeFichaPercentages();
      this.loading = false;
    });
  }

  loading = false;
  get disable_search_btn() {
    const hasCampaign = this.filter.campaign_id !== null;
    const selectedHospitals = Array.isArray(this.filter.hospital_id)
      ? this.filter.hospital_id.filter((v) => !!v)
      : [this.filter.hospital_id].filter((v) => !!v);
    const hasHospitals = selectedHospitals.length > 0;
    const placeholderSelected = Array.isArray(this.filter.hospital_id)
      ? this.filter.hospital_id.includes('')
      : this.filter.hospital_id === '';
    const requireHospitals = this.isAdmin === true;
    return this.loading || !hasCampaign || (requireHospitals && (!hasHospitals || placeholderSelected));
  }

  normalizeFichaPercentages() {
    try {
      const ficha = Array.isArray(this.retorno && this.retorno.ficha) ? this.retorno.ficha : [];
      for (let i = 0; i < ficha.length; i++) {
        const q = ficha[i];
        const items = Array.isArray(q && q.data) ? q.data : [];
        const totals = items.map((it) => Number((it && it.total) || 0));
        const sumTotal = totals.reduce((acc, n) => acc + n, 0);
        const pcts = items.map((it) => {
          const t = Number((it && it.total) || 0);
          const p = sumTotal ? (t * 100) / sumTotal : 0;
          return Math.round(p * 100) / 100;
        });
        const sumPct = Math.round(pcts.reduce((acc, n) => acc + n, 0) * 100) / 100;
        const remainder = Math.round((100 - sumPct) * 100) / 100;
        if (items.length && remainder !== 0) {
          let idx = 0;
          let max = -1;
          for (let k = 0; k < totals.length; k++) {
            if (totals[k] > max) {
              max = totals[k];
              idx = k;
            }
          }
          pcts[idx] = Math.round((pcts[idx] + remainder) * 100) / 100;
        }
        for (let j = 0; j < items.length; j++) {
          if (items[j]) items[j].pct = pcts[j];
        }
        if (!q.abstract) q.abstract = {};
        q.abstract.total = sumTotal;
        q.abstract.pct = 100;
      }
    } catch (_) {}
  }

  get label_search_btn() {
    return this.loading ? "CARREGANDO..." : "PESQUISAR";
  }

  select(item) {
    this.retorno.ficha = this.retorno.ficha.map((m) => {
      m.selected = false;
      return m;
    });
    item.selected = true;
    this.type = item;
    setTimeout(() => {
      this.charts(item.chart);
    }, 1000);
  }

  get public_route() {
    return parent.location.pathname.indexOf("statistics") !== -1;
  }

  countDiagnostic(item) {
    if (this.consult !== null) {
      return this.consult.filter((f) => f[this.type.name] === item.value)
        .length;
    } else {
      return 0;
    }
  }

  percentDiagnostic(item) {
    try {
      if (this.consult && this.consult.length !== 0 && this.type && Array.isArray(this.type.data)) {
        const counts = this.type.data.map((d) => this.consult.filter((f) => f[this.type.name] === d.value).length);
        const total = counts.reduce((acc, n) => acc + n, 0);
        if (total === 0) return `0%`;
        const valueCount = this.consult.filter((f) => f[this.type.name] === item.value).length;
        const percent = (valueCount / total) * 100;
        return `${percent.toFixed(2)}%`;
      } else {
        return `0%`;
      }
    } catch (e) {}
  }

  selectPosto() {
    this.diagnostics = [];
    const ids = Array.isArray(this.filter.hospital_id)
      ? this.filter.hospital_id
      : [this.filter.hospital_id].filter((i) => i);
    if (this.isAdmin) {
      const hasPlaceholder = ids.includes('') || this.filter.hospital_id === '';
      if (hasPlaceholder) {
        this.filter.hospital_id = null;
        this.posto = null;
        return;
      }
    }
    const names = this.services
      .filter((f) => ids.includes(f.value))
      .map((f) => f.label);
    this.posto = names.length ? names.join(", ") : null;
  }

  charts(chart) {
    this.canvas = document.getElementById("chart");
    this.ctx = this.canvas.getContext("2d");
    if (this.chart) {
      this.chart.reset();
    }
    this.chart = new Chart(this.ctx, {
      type: "pie",
      data: chart,
      options: {
        responsive: true,
      },
    });
  }

  onCampaignChange(value) {
    this.filter.campaign_id = value;
    if (this.isAdmin) {
      this.filter.hospital_id = this.services.map((s) => s.value);
    }
  }
}
